const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/sagas/autoLoginSaga.ts';
import { SagaIterator } from 'redux-saga';
import { put, select, take } from 'redux-saga/effects';
import { Logger } from '@cistec/common_web/services/KisLoggerService';
import { setLoginDataAtAutoLogin } from 'App/actions/fixme.login';
import { showSnackbar, showUncaughtErrorDialog } from '@cistec/common_web/actions/uiActions';
import { LoginData, PrefLang } from 'App/defs/loginDefs';
import { push, replace } from 'redux-first-history';
import textMap from './translations';
import { isSecuredLocationPath } from 'App/utils/urlLocationCheck';
import { PATH_DASHBOARD } from 'App/defs/router';
import { ACTION_TYPE_RESET_SESSION_STORAGE } from 'App/actions/fixme.login.actionTypes';
import { REQUEST_ACTION_TYPES_LOAD_REGISTER_WORK_ITEM } from 'App/actions/workItem';
import { isLoggedIn } from 'App/store/login';
import { getConfiguration } from 'App/utils/clientSetupGetRessource';
import { LanguageCode } from 'App/defs/setupDefs';
import { SupportedLocale } from '@cistec/common_web/defs/generalDefs';
import { actionSetI18nLocale } from '@cistec/common_web/actions/intlActions';

const Log = Logger('autoLogin');

export function* autoLoginSaga(): SagaIterator {
    try {
        const languageCode = ((): SupportedLocale => {
            const configuration = getConfiguration();
            const supportedLanguages = configuration.languages;
            const storedLanguageCode = JSON.parse(localStorage.getItem(PrefLang) as string);
            if (storedLanguageCode && supportedLanguages.includes(storedLanguageCode.toLowerCase())) {
                return storedLanguageCode;
            }
            const languages = navigator.languages;
            for (const language in languages) {
                const languageSimplified = language.split('-')[0].toLowerCase() as LanguageCode;
                if (supportedLanguages.includes(languageSimplified)) {
                    return languageSimplified;
                }
            }
            if (supportedLanguages.length) {
                return supportedLanguages[0];
            }
            return 'de';
        })();
        yield put(actionSetI18nLocale(languageCode));

        const loggedIn = yield select(isLoggedIn);
        if (!loggedIn) {
            const token = JSON.parse(sessionStorage.getItem(LoginData) as string);
            const currLocation = location.hash.replace('#', '');

            if (token && !isSecuredLocationPath()) {
                if (currLocation.startsWith('/app/login')) {
                    yield put({ type: ACTION_TYPE_RESET_SESSION_STORAGE });
                    if (currLocation !== '/app/login') {
                        yield put(push('/app/login'));
                    }
                } else {
                    yield put(setLoginDataAtAutoLogin(token));
                    if (currLocation !== PATH_DASHBOARD && !currLocation.startsWith('/app/login')) {
                        yield put(replace(PATH_DASHBOARD));
                    }
                    const action = yield take([
                        REQUEST_ACTION_TYPES_LOAD_REGISTER_WORK_ITEM.success,
                        REQUEST_ACTION_TYPES_LOAD_REGISTER_WORK_ITEM.failure,
                    ]);

                    if (
                        action?.type === REQUEST_ACTION_TYPES_LOAD_REGISTER_WORK_ITEM.failure ||
                        action.payload.STATUS === 'I'
                    ) {
                        yield put(push('/app/login'));
                        yield put({ type: ACTION_TYPE_RESET_SESSION_STORAGE });
                        yield put(showSnackbar(textMap.oldFormData));
                    }
                }
            } else if (isSecuredLocationPath()) {
                yield put(push(PATH_DASHBOARD));
                yield put(replace(PATH_DASHBOARD));
            } else {
                if (currLocation !== '/app/login') {
                    yield put(push('/app/login'));
                    yield put(replace('/app/login'));
                }
            }
        }
    } catch (exc) {
        yield put(showUncaughtErrorDialog('autoLoginSaga', exc));
        Log.error('EXCEPTION caught: ', exc);
    }
}
